import React, { Component } from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { withRouter } from 'next/router'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import Text from '../Text'
import NoImg from '../icons/NoImg'
import { EventTrackingConsumer } from '../EventTrackingProvider/EventTrackingProvider'
import { SCREEN_SIZE } from '../../lib/Media'
import { Router } from '../../routes'
import { GTM_ENV_VAR as GEV, SPLIT_EVENT } from '../../lib/eventTrackerFunction'
import { IdleQueue } from '../../lib/idlize/IdleQueue'
const queue = new IdleQueue()
import GlobalContext from '../GlobalContext'
import { generateQuery } from './CategoryCardUtils'
import { AMP_EVENT_NAME as AEN } from '../../lib/amplitude'

const CategoryCardWrap = styled.div`
  display: inline-block;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  overflow: hidden;
  background-color: #ffffff;
  flex-shrink: 0;
  margin: 0 0.5rem 0.5rem 0;
  position: relative;
  width: ${props => (props.cardSize ? '6.5rem' : '9.75rem')};
  height: ${props => (props.cardSize ? '9.5rem' : '9.75rem')};

  ${SCREEN_SIZE.From.MobileL} {
    width: ${props => (props.cardSize ? '6.5rem' : '14rem')};
    height: ${props => (props.cardSize ? '9.5rem' : '13.0625rem')};
  }

  &:hover {
    box-shadow: 2px 2px 6px 0 rgba(105, 105, 105, 0.2);
    border-radius: 4px;
  }
`

const StyledA = styled.a`
  display: block;
  height: 100%;
  text-decoration: none;
`

const StyledImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`

const CardImageContainer = styled.div`
  height: 6.5rem;
  margin: 0 auto;
  display: block;
  border-bottom: 1px solid #eaeaea;

  ${SCREEN_SIZE.From.Tablet} {
    height: ${props => (props.cardSize ? '6.5rem' : '9.3125rem')};
    max-width: 100%;
    object-fit: cover;
  }
`

const NoImgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #eaeaea;
  overflow: hidden;
  height: 6.5rem;

  ${SCREEN_SIZE.From.Tablet} {
    height: ${props => (props.cardSize ? '6.5rem' : '9.3125rem')};
  }
`

const CardCount = styled.div`
  min-width: 2.5rem;
  height: 1rem;
  line-height: 0.75rem;
  background-color: #f3f5f7;
  border: 1px solid #eaeaea;
  border-radius: 1rem;
  text-align: center;
  position: absolute;
  bottom: ${props => (props.cardSize ? '3.3rem' : '4rem')};
  right: 0.5rem;
`

const CardContent = styled.div`
  padding: 0.5rem;
  ${SCREEN_SIZE.From.Tablet} {
    ${props => props.cardSize && `margin: 0.75rem;`}
  }
  ${SCREEN_SIZE.Only.Mobile} {
    h2 {
      font-size: 0.85rem;
    }
    h3 {
      font-size: 0.75rem;
    }
  }
`

const CardHeading = styled(Text)`
  ${props =>
    props.cardSize
      ? `overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;`
      : `
overflow: hidden;
position: relative;
line-height: 1.2em;
max-height: 2.4em;
padding-right: 0.5em;
&:before {
content: '...';
position: absolute;
right: 0;
bottom: 0;
}
&:after {
content: '';
position: absolute;
right: 0;
width: 1em;
height: 1em;
margin-top: 0.2em;
background: white;
}`}
`

const CardSubHeading = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 0;
`

class CategoryCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isBrokenImage: false,
    }
    this.categoryCollectioRef = null

    this.setCategoryCollectioRef = element => {
      this.categoryCollectioRef = element
    }

    this.createObserver = this.createObserver.bind(this)
    this.bannerImpressionsTrackingData = this.bannerImpressionsTrackingData.bind(
      this
    )
    this.handleTrackOnClick = this.handleTrackOnClick.bind(this)
  }

  bannerImpressionsTrackingData() {
    const { collection, bannerPosition, checkoutAddress, title } = this.props
    const { id, image } = collection.category
    const { asPath } = generateQuery(this.props)
    return {
      refId: `${checkoutAddress?.clientId}-${id}`,
      [GEV.ECOMM_ID]: title || '',
      [GEV.ECOMM_NAME]: image || '',
      [GEV.ECOMM_CREATIVE]: asPath || '',
      [GEV.ECOMM_POSITION]: bannerPosition,
    }
  }

  handleTrackOnClick(e) {
    e.preventDefault()
    const { track, trackSplit } = this.props
    if (this.props.trackBannerImpressions) {
      this.props.trackBannerImpressions({ action: 'abandon' })
    }
    const bannerData = this.bannerImpressionsTrackingData()
    if (this.props.router?.pathname !== '/') {
      track({
        [GEV.AMPLITUDE_EVENT_NAME]: AEN.CATEGORY_CLICKED,
        [GEV.AMPLITUDE_CTA_LOCATION]: this.props.ctaLocation,
        [GEV.AMPLITUDE_CTA_SUBLOCATION]: this.props.ctaSublocation,
        [GEV.AMPLITUDE_CATEGORY_NAME]: this.props.collection?.category?.name,
        [GEV.AMPLITUDE_CATEGORY_LEVEL]: 3,
      })
    } else {
      track({
        [GEV.EVENT]: 'promotionClick',
        [GEV.ECOMMERCE]: {
          promoClick: {
            promotions: [bannerData],
          },
        },
        [GEV.AMPLITUDE_EVENT_NAME]: AEN.BANNER_CLICKED,
        [GEV.AMPLITUDE_CTA_LOCATION]: this.props.ctaLocation,
        [GEV.AMPLITUDE_CTA_SUBLOCATION]: this.props.ctaSublocation,
      })

      trackSplit([
        {
          event_type: SPLIT_EVENT,
          [GEV.EVENT]: 'splitPromoClick',
          ...bannerData,
        },
      ])
    }

    const { href, asPath } = generateQuery(this.props)
    if (asPath === '/tag/dc-redirect') {
      Router.push('membership/registration')
    } else if (asPath === '/tag/recipes-redirect') {
      Router.push('recipes')
    } else {
      Router.push(href, asPath)
    }
  }

  createObserver(params = {}) {
    if (this.props.createObserver) {
      const bannerData = this.bannerImpressionsTrackingData()
      const options = {
        productRef: this.categoryCollectioRef,
        bannerTrackObj: bannerData,
        callAction: 'onLoad',
      }
      if (params?.action === 'afterUpdate') {
        options.callAction = 'afterUpdate'
      }
      this.props.createObserver(options)
    }
  }

  componentWillUnmount() {
    this.categoryCollectioRef = null
  }

  componentDidMount() {
    const { collection } = this.props
    if (
      collection &&
      collection.category &&
      Object.keys(collection.category).length
    ) {
      queue.pushTask(() => {
        this.createObserver()
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { collection, checkoutAddress } = this.props
    if (
      prevProps.checkoutAddress.storeId !== checkoutAddress.storeId &&
      collection &&
      collection.category &&
      Object.keys(collection.category).length
    ) {
      this.createObserver({ action: 'afterUpdate' })
    }
  }

  render() {
    const { isBrokenImage } = this.state
    const {
      collection,
      cardSize,
      showProductCount,
      checkoutAddress,
    } = this.props
    const { href, asPath } = generateQuery(this.props)
    return (
      <CategoryCardWrap
        cardSize={cardSize}
        className={'category' + (collection.category.image ? '' : ' no-img')}
        ref={this.setCategoryCollectioRef}
        data-refid={`${checkoutAddress?.clientId}-${collection.category.id}`}
        data-impressiontype={this.props.impressionType}
        role="cell"
      >
        <Link href={href} as={asPath} passHref prefetch={false} legacyBehavior>
          <StyledA
            onClick={this.handleTrackOnClick}
            data-testid="category-card-link"
          >
            {collection.category.image ? (
              <CardImageContainer cardSize={cardSize}>
                {!isBrokenImage ? (
                  <StyledImage
                    src={
                      (collection.category &&
                        typeof collection.category.image === 'string' &&
                        `${collection.category.image.replace(
                          /XL/g,
                          'L'
                        )}?q=60&h=200`) ||
                      `${collection.category.image}?q=60&h=200`
                    }
                    alt={collection.category.name}
                    onError={() => {
                      this.setState({
                        isBrokenImage: true,
                      })
                    }}
                  />
                ) : (
                  <NoImgContainer cardSize={cardSize}>
                    <NoImg height="9.7rem" width="50%" />
                  </NoImgContainer>
                )}
              </CardImageContainer>
            ) : (
              <NoImgContainer
                cardSize={cardSize}
                data-testid="no-image-container"
              >
                <NoImg height="9.7rem" width="50%" />
              </NoImgContainer>
            )}
            {showProductCount && (
              <CardCount
                cardSize={cardSize}
                data-testid="category-card-product-count"
              >
                <Text size="small" color="#696969" weight="bold">
                  {collection.category.productsCount}
                </Text>
              </CardCount>
            )}
            <CardContent>
              <CardHeading
                as="h2"
                size={cardSize ? 'small' : 'medium'}
                color={defaultTheme.ColorBaseMineShaft700}
                weight="bold"
                title={collection.category.name}
                data-testid="category-card-heading"
              >
                {collection.category.name}
              </CardHeading>
              {collection.category.tagLine && (
                <CardSubHeading
                  as="h3"
                  size="small"
                  weight="bold"
                  color={defaultTheme.ColorBaseMineShaft500}
                  data-testid="category-card-sub-heading"
                >
                  {collection.category.tagLine}
                </CardSubHeading>
              )}
            </CardContent>
          </StyledA>
        </Link>
      </CategoryCardWrap>
    );
  }
}

const CategoryCardWrapper = withRouter(props => (
  <GlobalContext.Consumer>
    {({ remoteConfig }) => (
      <EventTrackingConsumer>
        {({ track, trackSplit }) => (
          <CategoryCard
            {...props}
            track={track}
            trackSplit={trackSplit}
            remoteConfig={remoteConfig}
          />
        )}
      </EventTrackingConsumer>
    )}
  </GlobalContext.Consumer>
))

CategoryCardWrapper.defaultProps = {}

export default CategoryCardWrapper
